// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function simplifyQueryObject<T extends Record<string, any>>(
  input: T = {} as T
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> {
  const output = Object.keys(input).reduce((acc, item) => {
    const value = input[item]

    // eslint-disable-next-line no-param-reassign
    acc[item] =
      Array.isArray(value) || typeof value === 'object' ? value?.[0] : value

    return acc
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as Record<string, any>)

  return output
}
